import { render, staticRenderFns } from "./DakejianLayout.vue?vue&type=template&id=95b9f8a2&scoped=true&"
import script from "./DakejianLayout.vue?vue&type=script&lang=js&"
export * from "./DakejianLayout.vue?vue&type=script&lang=js&"
import style0 from "./DakejianLayout.vue?vue&type=style&index=0&id=95b9f8a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b9f8a2",
  null
  
)

export default component.exports